/**
 * OTURUM SATIRININ OKUNUR CİHAZ ADI — web, panel ve mobil AYNI eşlemeyi okur.
 *
 * KUSUR 1 (mobil elle test · bulgu 11): ekran "Tanımadığın bir cihaz görürsen
 * oturumunu kapat" diyordu ama satırlar ham `User-Agent` basıyordu
 * (`okhttp/4.9.2`, `curl/8.7.1`). Kullanıcı kendi telefonunu başkasınınkinden
 * ayırt edemiyordu, yani ekranın vaat ettiği kararı veremiyordu.
 *
 * KUSUR 2 (kullanıcı webde gördü): ham dize DAHİLİ KOD ADINI sızdırıyordu —
 * `IcebreakerMobile/1 CFNetwork/3860.600.12 Darwin/25.5.0`. ESKİ AD, GERİYE UYUM:
 * iOS proje adı 24.09.2026'da `WarmBreak` oldu, ama o tarihten önce açılmış
 * oturumların kaydı bu dizeyi taşımaya devam eder; `cfnetwork|darwin` kuralı
 * eski ve yeni adı AYNI etikete çevirir (spec iki adı da sınar). Kod adı kullanıcıya
 * görünmez (CLAUDE.md P9); üstelik ham `User-Agent` zaten kullanıcıya
 * gösterilecek bir metin değildir. Bu yüzden ham dize HİÇBİR yüzeyde
 * ÇİZİLMEZ — ikincil metin olarak da durmaz.
 *
 * Blok 24'teki `wallet-text` taşımasıyla aynı gerekçe: eşleme mobilde tek
 * kopyaydı, web ve panel kendi satırlarında ham dizeyi basmaya devam ediyordu.
 *
 * UYDURMA YOK (CLAUDE.md 9): ham dizeden OKUNABİLEN ne varsa o yazılır; hiçbir
 * şey okunamıyorsa "Bilinmeyen cihaz" denir.
 */
const OS_RULES = [
    { test: /iphone/i, label: 'iPhone' },
    { test: /ipad/i, label: 'iPad' },
    { test: /android/i, label: 'Android' },
    { test: /windows nt/i, label: 'Windows' },
    { test: /mac os x|macintosh/i, label: 'macOS' },
    { test: /cros/i, label: 'ChromeOS' },
    { test: /linux/i, label: 'Linux' },
];
/** Sıra ÖNEMLİ: Chrome ve Edge kendilerini Safari diye de tanıtır. */
const BROWSER_RULES = [
    { test: /edg[ea]?\//i, label: 'Edge' },
    { test: /opr\/|opera/i, label: 'Opera' },
    { test: /(crios|chrome)\//i, label: 'Chrome' },
    { test: /(fxios|firefox)\//i, label: 'Firefox' },
    { test: /safari\//i, label: 'Safari' },
];
/** Tarayıcı olmayan istemciler; adları ürünün kendi adı değildir, olduğu gibi yazılır. */
const TOOL_RULES = [
    { test: /^curl\//i, label: 'curl' },
    { test: /^wget\//i, label: 'Wget' },
    { test: /postmanruntime/i, label: 'Postman' },
    { test: /insomnia/i, label: 'Insomnia' },
    { test: /python-requests|httpie|axios\//i, label: 'HTTP' },
];
/** Mobil uygulamanın kendi gönderdiği platform etiketleri (`buildAppUserAgent`). */
export const APP_USER_AGENT_PLATFORMS = ['iOS', 'Android'];
/**
 * KENDİ İSTEMCİMİZİN KİMLİĞİ — `<ürün>/<sürüm> (iOS|Android)`.
 *
 * Ürün adı MARKA TOKENINDAN gelir, yani burada dize olarak ARANMAZ: desen
 * yalnız BİÇİMİ tanır. Marka değişince bu desen çalışmaya devam eder.
 *
 * BİÇİM EŞLEŞMESİ YETERLİDİR, ÇÜNKÜ ETİKET BİR GÜVEN SİNYALİ DEĞİLDİR
 * (tech-lead kararı 21.09.2026): `User-Agent` tamamen İSTEMCİNİN beyanıdır ve
 * her değeri taklit edilebilir. Desene marka adını da eklemek hiçbir saldırıyı
 * engellemez — taklit eden marka adını da yazar. Bu satır bu yüzden yalnız
 * OKUNURLUK içindir; yetki ya da kimlik kararı ASLA buna dayandırılmaz
 * (oturumun kimliği sunucudaki kayıttır, dizede değil).
 * Tarayıcı dizeleri eşleşmez: hepsi `Mozilla/5.0 (…)` ile başlar ve parantez
 * içinde platform etiketinden fazlasını taşır (`$` çapası bunu keser).
 */
const APP_USER_AGENT = /^[^\s/]+\/[^\s]+ \((iOS|Android)\)$/;
/** İstemci kimliğini ÜRETEN tek nokta — mobil bunu `User-Agent` olarak gönderir. */
export function buildAppUserAgent(productName, version, platform) {
    return `${productName}/${version} (${platform})`;
}
export function appUserAgentPlatform(userAgent) {
    const match = APP_USER_AGENT.exec(userAgent.trim());
    return match === null ? null : match[1];
}
function match(rules, value) {
    for (const rule of rules) {
        if (rule.test.test(value))
            return rule.label;
    }
    return null;
}
/**
 * Satır başlığı. Sıra: kendi istemcimiz → uygulamanın HTTP yığını → tarayıcı
 * (+işletim sistemi) → araç → yalnız işletim sistemi → bilinmeyen.
 *
 * İkinci basamak GERİYE DÖNÜK: istemci başlığı eklenmeden ÖNCE açılmış
 * oturumların kaydı hâlâ `okhttp/…` ya da `CFNetwork/… Darwin/…` taşıyor.
 */
export function deviceLabel(t, session, options = {}) {
    const unknownKey = options.unknownKey ?? 'sessions.unknownDevice';
    const agent = session.userAgent?.trim() ?? '';
    if (agent.length === 0)
        return t.t(unknownKey);
    const appPlatform = appUserAgentPlatform(agent);
    if (appPlatform === 'iOS')
        return t.t('sessions.deviceIosApp');
    if (appPlatform === 'Android')
        return t.t('sessions.deviceAndroidApp');
    const os = match(OS_RULES, agent);
    /* Uygulamanın kendi HTTP yığını: Android'de okhttp, iOS'ta CFNetwork/Darwin. */
    if (/okhttp\//i.test(agent))
        return t.t('sessions.deviceAndroidApp');
    if (/cfnetwork|darwin/i.test(agent))
        return t.t('sessions.deviceIosApp');
    const browser = match(BROWSER_RULES, agent);
    if (browser) {
        return os
            ? t.t('sessions.deviceBrowserOnOs', { browser, os })
            : t.t('sessions.deviceBrowserOnly', { browser });
    }
    const tool = match(TOOL_RULES, agent);
    if (tool)
        return t.t('sessions.deviceTool', { tool });
    if (os)
        return os;
    return t.t(unknownKey);
}
//# sourceMappingURL=session-device-text.js.map